import { controlEventReportApi } from "./axios";
import { ServiceResponseI, ReportListItemI, ReportDetailI } from "@interfaces";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";

export const getControlEventReportsByEvent = async (
  controlEventId: string,
): Promise<ServiceResponseI<ReportListItemI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    params.append("controlEventId", controlEventId);

    const { data } = await controlEventReportApi.get<
      ServiceResponseI<ReportListItemI[]>
    >("", { params, headers: { Authorization: validateToken } });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const getControlEventReportByHash = async (
  hash: string,
  userId?: string,
): Promise<ServiceResponseI<ReportDetailI>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);

    const { data } = await controlEventReportApi.get<
      ServiceResponseI<ReportDetailI>
    >(`/${hash}`, { params, headers: { Authorization: validateToken } });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};
